import * as React from "react";
import "./LoaderIcon.css";

export interface LoaderIconProps
{
}

export class LoaderIcon extends React.Component<LoaderIconProps, {}>
{

    constructor(props: any, context?: any)
    {
        super(props, context);
    }

    render()
    {
        return <div className="LoaderIcon">
            <div>
                <div className="lds-dual-ring">
                    <div></div>
                </div>
            </div>
        </div>
    }
}